import { CheckCircle2, LoaderCircle } from "lucide-react";
import type { AutomationRun } from "@lumen/shared";

export function AutomationRunIcon({
  status,
}: {
  status: AutomationRun["status"];
}) {
  return status === "completed" ? (
    <CheckCircle2 className="text-emerald-500" size={19} />
  ) : status === "running" || status === "queued" ? (
    <LoaderCircle className="animate-spin text-lumen-600" size={19} />
  ) : (
    <span className="grid size-5 place-items-center rounded-full bg-red-100 text-xs text-red-600">
      !
    </span>
  );
}
